interface StoreBadgeProps {
  href: string;
  src: string;
  alt: string;
  testId: string;
}

export function StoreBadge({ href, src, alt, testId }: StoreBadgeProps) {
  return (
    <a
      href={href}
      target='_blank'
      rel='noopener noreferrer'
      data-testid={testId}
      className='inline-block'
    >
      <img src={src} alt={alt} className='h-14' />
    </a>
  );
}
